import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import * as moment from 'moment';
import { ResolveAssetPipe } from '../../backpack/resolve-asset.pipe';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	selector: 'sp-calendar-year-nav',
	template: `
		<div class="year-nav">
			<div class="switch-year __left" (click)="prevYear()">
				<img class="year-icon" [src]="'./assets/Chevron Left (Navy).svg' | resolveAsset" alt="Previous Year" />
			</div>
			<span class="ds-dialog-subtitle">{{ currentDate.format('YYYY') }}</span>
			<div class="switch-year __right" (click)="nextYear()">
				<img class="year-icon" [src]="'./assets/Chevron Right (Navy).svg' | resolveAsset" alt="Next Year" />
			</div>
		</div>
	`,
	styles: [
		`
			.year-nav {
				padding: 10px 5px 10px 5px;
				display: flex;
				flex-direction: row;
				justify-content: center;
				position: relative;
				.switch-year {
					display: flex;
					align-items: center;
					justify-content: center;
					position: absolute;
					border-radius: 50%;
					cursor: pointer;
					&.__right {
						right: 0;
					}
					&.__left {
						left: 0;
					}
					&:hover {
						background-color: #e4ebff;
						box-shadow: 0 0 0 5px #e4ebff;
					}
					.year-icon {
						width: 15px;
					}
				}
			}
		`,
	],
	imports: [ResolveAssetPipe],
})
export class CalendarYearNavComponent {
	@Input() currentDate: moment.Moment = moment();
	@Output() yearChange = new EventEmitter<moment.Moment>();

	prevYear() {
		this.yearChange.emit(this.currentDate.clone().subtract(1, 'year'));
	}

	nextYear() {
		this.yearChange.emit(this.currentDate.clone().add(1, 'year'));
	}
}
